import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';

const POINT_DIALOG_SHOWN_KEY = 'point-dialog-shown';

export const usePointDialog = () => {
  const [openPointCommonDialog, setOpenPointCommonDialog] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === '/home') {
      const hasShown = Cookies.get(POINT_DIALOG_SHOWN_KEY);
      if (!hasShown) {
        setOpenPointCommonDialog(true);
      }
    }
  }, [pathname]);

  const handleCloseDialog = (open: boolean) => {
    setOpenPointCommonDialog(open);
    if (!open) {
      Cookies.set(POINT_DIALOG_SHOWN_KEY, 'true');
    }
  };

  return {
    openPointCommonDialog,
    setOpenPointCommonDialog: handleCloseDialog,
  };
};
